import { Component, Inject, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-permanently-close-popup",
    templateUrl: "./permanently-close-popup.component.html",
    styleUrls: ["./permanently-close-popup.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class PermanentlyCloseComponent implements OnDestroy {
  UserID: string;
  userData: Data;
  private unsubscribe$ = new Subject<void>();
  selectedLanguage: string;
  constructor(
    private dialogRef: MatDialogRef<PermanentlyCloseComponent>,
    private authService: AuthService,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {
    this.authService.selectedlanguage$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }
  ngOnDestroy(): void {
    this.unsubscribe$?.next();
    this.unsubscribe$?.complete();
  }

  // This method is used to close the dialog
  close() {
    this.dialogRef.close();
  }

}
